import { useEffect, useMemo, useContext, useRef } from 'react';
import qs from 'qs';
import { SearchContext } from '../Contexts';

const QueryStringParams = ({ isLoaded, searchId, cleanQueryString, isTabsLoaded }) => {
  const {
    setQuery,
    query,
    setSelectedTab,
    selectedTab,
    tabs,
    selectedFacets,
    facetsLists,
    setFacetsLists,
    years,
    setDropdownValue,
    setDateRange,
    setExpandedOptions,
    setSelectedFacets
  } = useContext(SearchContext);

  const firstLoad = useRef(true);

  const firstLoadQuery = useMemo(() => {
    const qsParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    return qsParams;
  }, []);

  const firstLoadFacets = useMemo(() => {
    const facets = {};
    Object.keys(firstLoadQuery).forEach(key => {
      if (facetsLists.find(facet => facet.mainValue === key)) {
        facets[key] = firstLoadQuery[key];
      }
    });
    return facets;
  }, []);

  const addingFields = (facetValue, mainValue) => {
    const selectedFacetsClone = { ...selectedFacets };
    if (mainValue in selectedFacets) {
      // adding the values after the first time
      selectedFacetsClone[mainValue].push(facetValue);
    } else {
      // adding the value for the first time
      Object.assign(selectedFacetsClone, { [mainValue]: [facetValue] });
    }

    setSelectedFacets(selectedFacetsClone);
    // localStorage.setItem("selectedFacets", JSON.stringify(selectedFacetsClone));
  };

  const handleFilters = () => {
    const facetsListsClone = [...facetsLists];
    Object.keys(firstLoadQuery).forEach(key => {
      facetsListsClone.forEach(facetList => {
        if (facetList.mainValue === key) {
          facetList.facets.forEach(facet => {
            if (firstLoadQuery[key].includes(facet.value)) {
              facet.selected = true;
              addingFields(facet.value, facetList.mainValue);
              setExpandedOptions(true);
            }
            if (facet.childrens && facet.childrens.length) {
              facet.childrens.forEach(child => {
                if (firstLoadQuery[key].includes(child.value)) {
                  child.selected = true;
                  addingFields(child.value, facetList.mainValue);
                  setExpandedOptions(true);
                }
              });
            }
          });
        }
      });
    });
    setFacetsLists(facetsListsClone);
  };

  useEffect(() => {
    const setQueryStringValues = () => {
      if (firstLoadQuery.tab) {
        tabs.forEach(tab => {
          if (tab.value === firstLoadQuery.tab) {
            setSelectedTab(tab);
          }
        });
      }

      if (firstLoadQuery.query) {
        setQuery(firstLoadQuery.query);
      }

      if (firstLoadQuery.query) {
        setQuery(firstLoadQuery.query);
      }

      if (firstLoadQuery.From || firstLoadQuery.To) {
        setDateRange([
          {
            label: 'From',
            value:
              years.includes(Number(firstLoadQuery.From)) && firstLoadQuery.From
                ? firstLoadQuery.From
                : '',
            placeholder: 'Year'
          },
          {
            label: 'To',
            value:
              years.includes(Number(firstLoadQuery.To)) && firstLoadQuery.To
                ? firstLoadQuery.To
                : '',
            placeholder: 'Year'
          }
        ]);

        setDropdownValue([
          years.includes(Number(firstLoadQuery.From)) && firstLoadQuery.From
            ? firstLoadQuery.From
            : 'Year',
          years.includes(Number(firstLoadQuery.To)) && firstLoadQuery.To
            ? firstLoadQuery.To
            : 'Year'
        ]);
      }

      handleFilters();
    };

    if (Object.keys(firstLoadFacets).length > 0) {
      setSelectedFacets(firstLoadFacets);
    }

    if (firstLoadQuery.searchId === searchId || !firstLoadQuery.searchId) {
      setQueryStringValues();
    }
  }, []);

  const buildQueryString = () => {
    const currentQsParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    const qsParams = {};

    if (query) {
      qsParams.query = query;
    }

    if (selectedFacets) {
      Object.keys(selectedFacets).forEach(key => {
        qsParams[key] = selectedFacets[key];
      });
    }

    Object.keys(firstLoadQuery).forEach(key => {
      if (facetsLists.find(facet => facet.mainValue === key)) {
        qsParams[key] = firstLoadQuery[key];
        selectedFacets[key] = firstLoadQuery[key];
      }
    });

    if (searchId && !firstLoad.current) {
      qsParams.searchId = searchId;
    }

    if (currentQsParams.searchId !== searchId) {
      cleanQueryString();
    }

    if(firstLoad.current) {
      firstLoad.current = false;
      return;
    }

    const qsValue = qs.stringify(qsParams, { arrayFormat: 'brackets' });

    // add this before qsValue to test with storybook
    // ?id=templates-insights-page--insights-page&args=&viewMode=story&practice%5B%5D=valueParentFacetOne&searchId=academySearch&query=efe#/academy
    const newUrl = `${window.location.protocol}//${window.location.host}${
      window.location.pathname
    }${qsValue ? `?${qsValue}` : ''}${window.location.hash}`;
    window.history.pushState(qsParams, '', newUrl);
  };

  useEffect(() => {
    if (isLoaded || isTabsLoaded) {
      buildQueryString();
    }
  }, [selectedFacets, query, selectedTab]);
};

export default QueryStringParams;
